import React, { Component } from "react";
import PropTypes from "prop-types";
import { Fieldset, Field, Control, Label, Input } from "rbx";

import { Mutation } from "react-apollo";
import Section from "../Section";
import { BooleanInput, EditFormButtonGroup, PhoneNumberInput } from "../inputs";
import {
  UPDATE_CUSTOMER_CONTACT_MUTATION,
  DELETE_CUSTOMER_CONTACT_MUTATION
} from "../../graphql/CustomerContacts/CustomerContacts.graphql";

class EditCustomerContactForm extends Component {
  state = {
    FirstName: "",
    LastName: "",
    JobTitle: "",
    BusinessPhone: "",
    MobilePhone: "",
    FaxNo: "",
    EmailAddress: "",
    Active: "",
    ...this.props.customerContact
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const {
      FirstName,
      LastName,
      JobTitle,
      BusinessPhone,
      MobilePhone,
      FaxNo,
      EmailAddress,
      Active
    } = this.state;
    const { setModalOpen, CustomerRecIdRef } = this.props;
    return (
      <Mutation
        mutation={UPDATE_CUSTOMER_CONTACT_MUTATION}
        refetchQueries={["ALL_CUSTOMER_CONTACTS_QUERY"]}
        variables={{
          data: {
            CustomerRecIdRef,
            FirstName,
            LastName,
            JobTitle,
            BusinessPhone,
            MobilePhone,
            FaxNo,
            EmailAddress,
            Active
          },
          where: {
            RecId: this.props.customerContact.RecId
          }
        }}
      >
        {(updateCustomerContact, { loading, error }) => (
          <form
            id="edit-customer-contact"
            onSubmit={async e => {
              e.preventDefault();
              await updateCustomerContact();
              setModalOpen(false);
            }}
          >
            <Fieldset disabled={loading}>
              <Section title="Edit Customer Contact">
                <Field kind="group">
                  <Control expanded>
                    <Label>First Name</Label>
                    <Input
                      autocomplete="new"
                      name="FirstName"
                      type="text"
                      value={FirstName}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Last Name</Label>
                    <Input
                      autocomplete="new"
                      name="LastName"
                      type="text"
                      value={LastName}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control expanded>
                    <Label>Business Phone</Label>
                    <PhoneNumberInput
                      name="BusinessPhone"
                      value={BusinessPhone}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Mobile Phone</Label>
                    <PhoneNumberInput
                      name="MobilePhone"
                      value={MobilePhone}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Fax No</Label>
                    <PhoneNumberInput
                      name="FaxNo"
                      value={FaxNo}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control>
                    <Label>Job Title</Label>
                    <Input
                      autocomplete="new"
                      name="JobTitle"
                      type="text"
                      value={JobTitle}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Email Address</Label>
                    <Input
                      autocomplete="new"
                      name="EmailAddress"
                      type="email"
                      value={EmailAddress}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Active</Label>
                    <BooleanInput
                      name="Active"
                      value={Active}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <EditFormButtonGroup
                  deleteMutation={DELETE_CUSTOMER_CONTACT_MUTATION}
                  form="edit-customer-contact"
                  refetchQueries={["ALL_CUSTOMER_CONTACTS_QUERY"]}
                  variables={{
                    where: { RecId: this.props.customerContact.RecId }
                  }}
                  onComplete={setModalOpen}
                />
              </Section>
            </Fieldset>
          </form>
        )}
      </Mutation>
    );
  }
}

EditCustomerContactForm.propTypes = {
  setModalOpen: PropTypes.func,
  CustomerRecIdRef: PropTypes.number.isRequired,
  customerContact: PropTypes.object
};
export default EditCustomerContactForm;
